import { lazy } from "react";

export const EmployerPageArticleContent = lazy(() => import("./EmployerPageArticleContent"));
